import {styled} from "@mui/material";
import ThemedText from "../../components/text";
import Label from "../../resources/label";
import Base from "../../components/base";
import DonorInfo from "../../components/form/donor-info";
import {buildPath, scale} from "../../utils";
import {User} from "../../types";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {useMediaQuery} from "@mui/system";
import theme from "../../constants/theme";


const Wrapper = styled('div')({
  display: 'flex',
  maxWidth: scale(1592),
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: scale(10),
  rowGap: scale(30),
  overflowX: 'hidden',
});

const TitleGroup = styled('div')({
  display: 'flex',
  width: scale(1592),
  height: scale(156),
  marginTop: scale(60),
  marginBottom: scale(37 - 17),
  flexDirection: 'column',
  rowGap: '5px',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
  },
});

const Home = () => {
  const navigate = useNavigate();
  const userData = localStorage.getItem('user')
  const user: User | null = userData ? JSON.parse(userData) as User : null;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (user?.role === 'OPERATOR') {
      navigate(buildPath('/operatore/calendario'))
    }
  }, [navigate, user?.role])

  return (
    <Wrapper>
      {!isMobile && (<ThemedText
        fontSize={scale(42)}
        align={'center'}
        fontWeight={300}
        lineHeight={scale(52)}
        letterSpacing={scale(0.42)}
        text={Label.HOME_HEADER}
      />)
      }
      <Base>
        <TitleGroup>
          <ThemedText
            text={Label.HOME_MODAL_TITLE}
            color={'primary'}
            fontSize={isMobile ? scale(28) : scale(24)}
            align={'center'}
            fontWeight={700}
            lineHeight={scale(29)}
            letterSpacing={scale(0.48)}
            sx={{height: scale(58)}}
          />
          <ThemedText
            text={Label.HOME_MODAL_SUBTITLE}
            color={'black'}
            fontSize={isMobile ? scale(24) : scale(20)}
            align={'center'}
            fontWeight={300}
            noWrap={false}
            sx={{width: isMobile ? scale(440) : undefined}}
          />
        </TitleGroup>
        <DonorInfo/>
      </Base>
    </Wrapper>
  );
};

export default Home;
